import { render, staticRenderFns } from "./ShippedOrdersTable.vue?vue&type=template&id=7e8290c8&scoped=true"
import script from "./ShippedOrdersTable.vue?vue&type=script&lang=js"
export * from "./ShippedOrdersTable.vue?vue&type=script&lang=js"
import style0 from "./ShippedOrdersTable.vue?vue&type=style&index=0&id=7e8290c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e8290c8",
  null
  
)

export default component.exports